var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer_status btn",style:({ 'background-color': _vm.getStatusColorData.background, color: _vm.getStatusColorData.text }),on:{"click":_vm.openEditor}},[_c('p',[_vm._v(_vm._s(_vm.payload.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }